import React from 'react'
import BuildScoreBoard from 'components/ExpandedInfo/BuildScoreBoard'

import Container from './styles'

function BuildScoreRelated(props) {
  const { scoreBoardData, isInDenyList } = props 
  return (
    <Container>
      <BuildScoreBoard scoreBoardData={scoreBoardData} isInDenyList={isInDenyList} />
    </Container>
  )
}

export default BuildScoreRelated
